export const lookbookPhotos = [
  {
    id: 'lb-1',
    image: 'https://readdy.ai/api/search-image?query=stylish%20asian%20woman%20in%20elegant%20cream%20beige%20silk%20blouse%20and%20wide%20leg%20trousers%20posing%20in%20minimalist%20bright%20interior%20warm%20natural%20light%20fashion%20editorial%20full%20body%20portrait%20sophisticated%20outfit&width=400&height=560&seq=lb1&orientation=portrait',
    tag: '職場穿搭',
    height: 'tall',
  },
  {
    id: 'lb-2',
    image: 'https://readdy.ai/api/search-image?query=fashionable%20asian%20woman%20in%20flowy%20midi%20dress%20warm%20sand%20tone%20standing%20outdoors%20by%20white%20wall%20soft%20sunlight%20editorial%20photography%20casual%20chic%20style&width=400&height=400&seq=lb2&orientation=squarish',
    tag: '週末休閒',
    height: 'medium',
  },
  {
    id: 'lb-3',
    image: 'https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20in%20luxurious%20cream%20satin%20wrap%20dress%20sitting%20gracefully%20on%20marble%20steps%20golden%20hour%20lighting%20upscale%20fashion%20lookbook%20photography&width=400&height=560&seq=lb3&orientation=portrait',
    tag: '優雅洋裝',
    height: 'tall',
  },
  {
    id: 'lb-4',
    image: 'https://readdy.ai/api/search-image?query=chic%20asian%20woman%20in%20cozy%20knit%20cardigan%20layered%20over%20slip%20dress%20autumn%20warm%20tones%20holding%20coffee%20cup%20standing%20by%20wooden%20door%20lifestyle%20fashion%20photography&width=400&height=400&seq=lb4&orientation=squarish',
    tag: '秋日層次',
    height: 'medium',
  },
  {
    id: 'lb-5',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20asian%20businesswoman%20in%20tailored%20cream%20blazer%20pencil%20skirt%20standing%20in%20modern%20office%20lobby%20confident%20pose%20fashion%20editorial%20sharp%20chic&width=400&height=520&seq=lb5&orientation=portrait',
    tag: '職場穿搭',
    height: 'tall',
  },
  {
    id: 'lb-6',
    image: 'https://readdy.ai/api/search-image?query=relaxed%20asian%20woman%20in%20linen%20co-ord%20set%20neutral%20tones%20sitting%20at%20outdoor%20cafe%20terrace%20natural%20light%20minimalist%20fashion%20lifestyle%20photography%20summer%20casual&width=400&height=380&seq=lb6&orientation=squarish',
    tag: '週末休閒',
    height: 'short',
  },
  {
    id: 'lb-7',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20asian%20woman%20in%20off-shoulder%20floral%20midi%20dress%20warm%20cream%20background%20golden%20jewellery%20soft%20romantic%20light%20editorial%20fashion%20photography%20feminine%20elegant&width=400&height=560&seq=lb7&orientation=portrait',
    tag: '優雅洋裝',
    height: 'tall',
  },
  {
    id: 'lb-8',
    image: 'https://readdy.ai/api/search-image?query=trendy%20asian%20woman%20in%20oversized%20beige%20trench%20coat%20white%20shirt%20straight%20jeans%20street%20style%20fashion%20photography%20clean%20background%20minimalist%20aesthetic&width=400&height=400&seq=lb8&orientation=squarish',
    tag: '秋日外套',
    height: 'medium',
  },
];
